import React from "react";
import { useParams } from "react-router-dom";
import MarketingPreferencesForm from "./MarketingPreferences/MarketingPreferencesForm";
import { Helmet } from "react-helmet";
import DefaultLayout from "../layouts/DefaultLayout";

// Unsubscribe tokens are 16+ chars of [a-zA-Z0-9-_]. The route's v5 pattern
// (":unsubscribeToken([a-zA-Z0-9-_]{16,})?") enforced this in the path; v6
// dropped regex params (#637), and because the param is OPTIONAL a failing
// value must mean "no token", not a 404 — so the check lives here.
const UNSUBSCRIBE_TOKEN_PATTERN = /^[a-zA-Z0-9-_]{16,}$/;

const PublicMarketingPreferences = () => {
  const { unsubscribeToken: rawToken } = useParams<{
    unsubscribeToken?: string;
  }>();
  const unsubscribeToken =
    rawToken && UNSUBSCRIBE_TOKEN_PATTERN.test(rawToken) ? rawToken : undefined;

  return (
    <DefaultLayout showTry={false} showSignIn={true}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FarmFLiX.tv | Marketing Preferences</title>
      </Helmet>
      <MarketingPreferencesForm
        unsubscribeToken={unsubscribeToken}
        embedded={false}
      />
    </DefaultLayout>
  );
};

export default PublicMarketingPreferences;
